import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AdditionalCommentsData,
  AdditionalCommentsLabel,
  AdditionalCommentsLayout
} from 'components/AdditionalComments/AdditionalComments.style';

const AdditionalComments = () => (
  <AdditionalCommentsLayout>
    <AdditionalCommentsLabel>
      <FormattedMessage id="additionalComments.header" />
    </AdditionalCommentsLabel>
    <AdditionalCommentsData>N/A</AdditionalCommentsData>
  </AdditionalCommentsLayout>
);

export default AdditionalComments;
